
export function elementDisplay(element: string, display:boolean, inputType:string) {

    let current_element = null;
    switch (inputType) {
        case "text":
        case "textarea":
            current_element = document.querySelectorAll<HTMLInputElement>(`${element}`);
            break;
        case "select":
            current_element = document.querySelectorAll<HTMLSelectElement>(`${element}`);
            break;
        case "div":
            current_element = document.querySelectorAll<HTMLElement>(`${element}`);
            break;
        default:
            current_element = document.querySelectorAll<HTMLElement>(`${element}`);
            break;
    }

    current_element.forEach((elem) => {
        if(display){
            elem.style.display = ''; // Hide the element
            elem?.classList.remove(`d-none`);
            // elem?.classList.remove(`form-elements-hide`);
        }
        else{
            elem?.classList.add(`d-none`);
        }
    });

}


export function elementSetAttribute(element: string, attribute:string, value:string, inputType:string) {

    let current_element = null;
    switch (inputType) {
        case "text":
        case "textarea":
            current_element = document.querySelectorAll<HTMLInputElement>(`${element}`);
            break;
        case "select":
            current_element = document.querySelectorAll<HTMLSelectElement>(`${element}`);
            break;
        default:
            current_element = document.querySelectorAll<HTMLElement>(`${element}`);
            break;
    }

    current_element.forEach((elem) => {
        if(attribute == "text" && elem){
            elem!.innerHTML = value ;
        }
        elem && elem.setAttribute(attribute, value);
    });

}



export function mandatoryInput(element: string, required:boolean, inputType:string) {

    let current_element = null;
    let current_element_asterisk = null;
    switch (inputType) {
        case "text":
        case "textarea":
            current_element = document.querySelector<HTMLInputElement>(`${element}`);
            current_element_asterisk = document.querySelector<HTMLElement>(`.${element.replace('#', '')}_asterisk`);
            if(current_element){
                current_element!.required = required;
                required ? current_element_asterisk?.classList.remove(`d-none`) : current_element_asterisk?.classList.add(`d-none`);
            }
            
            break;
        case "select":
            current_element = document.querySelector<HTMLSelectElement>(`${element}`);
            current_element_asterisk = document.querySelector<HTMLElement>(`.${element.replace('#', '')}_asterisk`);
            if(current_element && required == true ){
                current_element?.classList.add(`select-ddl-required`);
                current_element_asterisk?.classList.remove(`d-none`);
            }
            else{
                current_element?.classList.remove(`select-ddl-required`);
                current_element_asterisk?.classList.add(`d-none`);
            }
            break;
        default:
            current_element = document.querySelector<HTMLInputElement>(`${element}`);
            current_element_asterisk = document.querySelector<HTMLElement>(`.${element.replace('#', '')}_asterisk`);
            if(current_element){
                current_element!.required = required;
                required ? current_element_asterisk?.classList.remove(`d-none`) : current_element_asterisk?.classList.add(`d-none`);
            }
            break;
    }

}




export function disableInput(element: string, disabled:boolean, inputType:string) {
    
    let current_element = null;
    let current_select = null;
    let current_select_btn = null;



    switch (inputType) {
        case "text":
        case "textarea":
            current_element = document.querySelector<HTMLInputElement>(`${element}`);
            break;
        case "button":
            current_element = document.querySelector<HTMLButtonElement>(`${element}`);
            break;
        case "select":
            current_select = document.querySelector<HTMLSelectElement>(`${element} .react-select__control`);
            current_element = document.querySelector<HTMLSelectElement>(`${element} input`);
            current_select_btn = document.querySelector<HTMLElement>(`${element} .react-select__indicators`);
            if(disabled){
                current_select && current_select!.classList?.add('select-disabled');
                // if (current_select && current_select.parentElement) {
                //     current_select.parentElement.style.border = '1px solid #dee2e6';
                // }
                current_select_btn && current_select_btn!.classList.add('d-none');
            }
            else{
                current_select && current_select!.classList?.remove('select-disabled');
                current_select_btn && current_select_btn!.classList.remove('d-none');

            }
            break;
        default:
            current_element = document.querySelector<HTMLInputElement>(`${element}`);
            break;
    }
    if(current_element){
        current_element!.disabled = disabled; 
        // current_element.style.border = '1px solid #dee2e6';
        // const invalidFeedback = document.querySelector<HTMLElement>(`.${element.replace("#", "")}-invalid-feedback`);
        // if (invalidFeedback) {

        //     invalidFeedback.style.display = 'none'; // hide the invalid feedback element
        // }
    }
    

}


export const disableFormGroupInputs = (isDisabled = false) => {
    let formIsValid = true;

   const visibleFormGroups = Array.from(document.querySelectorAll<HTMLElement>('.form-group'))
    .filter(el => {
        const hasHiddenClasses = el.classList.contains('form-elements-hide') || el.classList.contains('d-none');
        
        // Find the closest parent with class 'form-group' and check if it has the class 'd-none'
        const parentIsHidden = el.parentElement?.classList.contains('form-elements-hide') || el.parentElement?.classList.contains('d-none');
        //const parentIsHidden = parentFormGroup && parentFormGroup !== el && (parentFormGroup.classList.contains('d-none') || parentFormGroup.classList.contains('form-elements-hide'));

        // Filter out elements that are either hidden themselves or whose parent form-group is hidden
        return !hasHiddenClasses && !parentIsHidden;
    });

    if (visibleFormGroups.length > 0) {
        visibleFormGroups.forEach((formElem) => {
            const inputs = formElem.querySelectorAll<HTMLInputElement>('input');
            // const datepickers = formElem.querySelectorAll<HTMLTextAreaElement>('.datepicker');
            const textAreas = formElem.querySelectorAll<HTMLTextAreaElement>('textarea');
            const selects = formElem.querySelectorAll<HTMLSelectElement>('.react-select-container');
            // const checkboxes = formElem.querySelectorAll<HTMLInputElement>('input[type="checkbox"]');

            inputs.forEach((input) => {
                if(input){
                    disableInput(`#${input.id}` , isDisabled, "text");
                }

            });

            textAreas.forEach((textarea) => {
                if(textarea){
                    disableInput(`#${textarea.id}` , isDisabled, "text");
                }
            });


            selects.forEach((select) => {
                if(select){
                    disableInput(`#${select.id}` , isDisabled, "select");
                    if(isDisabled){
                        select?.classList.add("select-ddl-disabled");
                    }
                    else{
                        select?.classList.remove("select-ddl-disabled");
                    }               
                }
            });

            // checkboxes.forEach((input) => {
            //     if(input){
            //         disableInput(input.id , isDisabled, "text");
            //         disableInput(input.className , isDisabled, "text");
            //     }

            // });


        });

    }
};


export function isElementVisible(id:string) {
//   const element = document.getElementById(id.replace("#", ""));
  const element = document.querySelector<HTMLElement>(id);
  if (!element) {
    return false; // Element does not exist
  }

  const style = window.getComputedStyle(element);
  const hasHiddenClass =
    element.classList.contains("d-none") ||
    element.classList.contains("form-elements-hide");

  let hasParentHiddenClass = false;
  // Bail out quickly if any ancestor (including itself) matches
  if (element.closest(".d-none, .form-elements-hide")) {
    hasParentHiddenClass = true;
  }
//   const rect = element.getBoundingClientRect();
  const isVisible = style.display !== 'none' && 
                    style.visibility !== 'hidden' && 
                    style.opacity !== '0' 
                    && !hasHiddenClass && !hasParentHiddenClass; 
                    // &&
                    // rect.width> 0 && 
                    // rect.height > 0;
//   console.log("hasParentHiddenClass:" + id + ":" + hasParentHiddenClass);
//   console.log("hasHiddenClass:" + id + ":" + hasHiddenClass);
//   console.log("isVisible:" + id + ":" + isVisible );
//     console.log("style.display !== 'none':" + (style.display !== 'none'));
//     console.log("style.visibility:" + (style.visibility));
//     console.log("style.opacity:" + (style.opacity));
//     console.log("element.offsetWidth" + (rect.width ));
//     console.log("element.offsetHeight:" + (rect.height));
  return isVisible;
}


// export function isElementVisible(selector: string) {
//   const element = document.querySelector<HTMLElement>(selector);
//   if (!element) return false;

//   // Check style
//   const style = window.getComputedStyle(element);
//   if (style.display === "none" || style.visibility === "hidden") {
//     return false;
//   }

//   // Check dimensions
//   if (element.offsetWidth === 0 || element.offsetHeight === 0) {
//     return false;
//   }

//   // Check if hidden by parent
//   let parent: HTMLElement | null = element;
//   while (parent) {
//     const parentStyle = window.getComputedStyle(parent);
//     if (parentStyle.display === "none" || parentStyle.visibility === "hidden") {
//       return false;
//     }
//     parent = parent.parentElement;
//   }

//   return true;
// }